import CommonFileUpload from "../../../../../coreComponents/CommonFileUpload";


// This component will handle product image and gallery uploads.
const Gallery = () => {
  return (
    <div className="sidebar-body">
      <div className="product-upload">
        <p>
          Product Image<span className="text-danger"> *</span>
        </p>
        <CommonFileUpload />
      </div>
      <div className="product-upload">
        <p>
          Product Gallery<span className="text-danger"> *</span>
        </p>
        <CommonFileUpload />
      </div>
    </div>
  );
};

export default Gallery;
